import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import LanguageContext from "../../contexts/LanguageContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  const {isEnglish} = useContext(LanguageContext);

  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {isEnglish ? "Made with ❤️ by Mateus Furrier" : "Feito com ❤️ por Mateus Furrier"}
        </p>

      </div>
    </Fade>
  );
}
